const serviceSchema = {
    feilds: [
      {
        id: 0,
        name: "addService",
        text: "Add New Service",
        visible: true,
        element: "label",
        className: [],
        required: false,
      },
      {
        id: 1,
        name: "Service",
        text: "Enter Service",
        visible: true,
        element: "input",
        required: true,
        input_type: "text",
        placeholder: "Enter Service",
        icon: "user",
        rules: [
          {
            test: (value) => {
              return value !== null && value.length > 0;
            },
            message: "Please Enter Service",
          },
        ],
        errors: [],
        value: null,
        valid: false,
        state: "",
        disable: false,
        className: "",
      },
      {
        id: 2,
        name: "code",
        text: "Enter Service Code",
        visible: true,
        element: "input",
        required: true,
        input_type: "text",
        placeholder: "Enter Service Code",
        icon: "user",
        rules: [
          {
            test: (value) => {
              return value !== null && value.length > 0;
            },
            message: "Please Enter Service Code",
          },
        ],
        errors: [],
        value: null,
        valid: false,
        state: "",
        disable: false,
        className: "",
      },
      {
        id: 3,
        name: "group",
        text: "Select Service Group",
        visible: true,
        element: "select2",
        required: true,
        input_type: "text",
        placeholder: "Select Service Group",
        rules: [
          {
            test: (value) => {
              return value !== null && value.length > 0;
            },
            message: "Please Select Service Group",
          },
        ],
        errors: [],
        value: null,
        valid: false,
        state: "",
        disable: false,
        className: "",
      },
      // {
      //   id: 5,
      //   name: "unit",
      //   text: "Select Unit",
      //   visible: false,
      //   element: "select2",
      //   required: true,
      //   input_type: "text",
      //   placeholder: "Select Unit",
      //   icon: "lock",
      //   rules: [
      //     {
      //       test: (value) => {
      //         return value && value !== null && value.length > 0;
      //       },
      //       message: "Please Select Unit",
      //     },
      //   ],
      //   errors: [],
      //   value: null,
      //   valid: false,
      //   state: "",
      //   disable: true,
      //   className: "",
      // },
    //   {
    //     id: 5,
    //     name: "unit",
    //     text: "Select Unit",
    //     visible: true,
    //     element: "Select2multiple",
    //     required: true,
    //     input_type: "text",
    //     placeholder: "Select Unit",
    //     icon: "lock",
    //     rules: [
    //       {
    //         test: (value) => {
    //           return value !== null && value.length > 0;
    //         },
    //         message: "Please Select Unit",
    //       },
    //     ],
    //     errors: [],
    //     value: null,
    //     valid: false,
    //     state: "",
    //     disable: true,
    //     className: "",
    //   },
      //   {
      //     id: 7,
      //     name: "department",
      //     text: "Select Department",
      //     visible: true,
      //     element: "select2",
      //     required: true,
      //     input_type: "text",
      //     placeholder: "Select Department",
      //     icon: "lock",
      //     rules: [
      //       {
      //         test: (value) => {
      //           return value !== null && value.length > 0;
      //         },
      //         message: "Please Select Department",
      //       },
      //     ],
      //     errors: [],
      //     value: null,
      //     valid: false,
      //     state: "",
      //     disable: true,
      //     className: 'col-4'
      //   },
      //   {
      //     id: 8,
      //     name: "service",
      //     text: "Select Service Group",
      //     visible: true,
      //     element: "select2",
      //     required: true,
      //     input_type: "text",
      //     placeholder: "Select Service Group",
      //     icon: "lock",
      //     rules: [
      //       {
      //         test: (value) => {
      //           return value !== null && value.length > 0;
      //         },
      //         message: "Please Service Group",
      //       },
      //     ],
      //     errors: [],
      //     value: null,
      //     valid: false,
      //     state: "",
      //     disable: true,
      //     className: 'col-4'
      //   },
      //////////////////////////////////////////////////////////////////////////////
      // {
      //   id: 6,
      //   name: "work_station",
      //   text: "Select Work Station",
      //   visible: false,
      //   element: "select2",
      //   required: true,
      //   input_type: "text",
      //   placeholder: "Select Work Station",
      //   icon: "lock",
      //   rules: [
      //     {
      //       test: (value) => {
      //         return value !== null && value.length > 0;
      //       },
      //       message: "Please Work Station",
      //     },
      //   ],
      //   errors: [],
      //   value: null,
      //   valid: false,
      //   state: "",
      //   disable: true,
      //   className: "",
      // },
      // {
      //   id: 7,
      //   name: "doctor_user_id",
      //   text: "Doctor User Id",
      //   visible: false,
      //   element: "input",
      //   required: true,
      //   input_type: "text",
      //   placeholder: "Enter  Doctor User Id",
      //   icon: "user",
      //   rules: [
      //     {
      //       test: (value) => {
      //         return value !== null && value.length > 0;
      //       },
      //       message: "Please Enter  Doctor User Id",
      //     },
      //   ],
      //   errors: [],
      //   value: null,
      //   valid: false,
      //   state: "",
      //   disable: true,
      //   className: "",
      // },
      {
        id: 8,
        name: "button",
        text: "User",
        visible: true,
        required: false,
        element: "button",
        input_type: "button",
        disable: false,
      },
    ],
  };

export {serviceSchema};